import { render, staticRenderFns } from "./projectManagement.vue?vue&type=template&id=73f9dac4&"
import script from "./projectManagement.vue?vue&type=script&lang=js&"
export * from "./projectManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports